import { Pipe, PipeTransform } from '@angular/core';
import { SELECTED_VENDOR } from '@app/_helpers';

@Pipe({
  name: 'unitFormatter'
})
export class UnitFormatterPipe implements PipeTransform {

  transform(value: number, shortUnit?: boolean, decimalPlaces?: number, ...args: unknown[]): string {
    if(!value) return value?.toString();
    let formattedValue = value.toString();
    let isNegative = value < 0 ;
    
    if(isNegative) {
      value = -value; 
    }

    const options = decimalPlaces? { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces } : {};
    if (value >= 1e7) {
      value = value / 1e7;
      value = isNegative? -value : value;
      formattedValue  = `${value.toLocaleString(SELECTED_VENDOR.locale, options)}${shortUnit ? ' Cr' : ' Crores'}`;
    } else if (value >= 1e5) {
      value = value / 1e5;
      value = isNegative? -value : value;
      formattedValue  = `${value.toLocaleString(SELECTED_VENDOR.locale, options)}${shortUnit ? ' L' : ' Lakhs'}`;
    } else if (value >= 1e3) {
      value = value / 1e3;
      value = isNegative? -value : value;
      formattedValue = `${value.toLocaleString(SELECTED_VENDOR.locale, options)}${shortUnit ? ' K' : ' Thousands'}`;
    }
    else {
      value = isNegative? -value : value;
      formattedValue  = `${value.toLocaleString(SELECTED_VENDOR.locale, options)}`;
    }

    return formattedValue;
  }

}
